import React from 'react';

import { cn } from '@lyearn/style';
import { Box, Typography } from '@lyearn/ui';
import { TypographyColors, TypographyVariants } from '@lyearn/ui';

interface Props {
  className?: string;
  iconClassName?: string;
  content: string;
  color?: {
    icon?: string;
    text?: TypographyColors;
  };
  variant: TypographyVariants;
  Icon?: (props: { className: string; fillColorToken: string }) => JSX.Element;
}

const InformationBox: React.FC<Props> = ({
  className,
  iconClassName,
  content,
  color = {},
  Icon,
  variant,
}) => {
  const { icon: iconColor = 'icon-primary', text: textColor = 'text-text-paragraph' } = color;
  return (
    <Box className={cn(className, 'flex items-center justify-center xs:flex-row')}>
      {Icon ? (
        <Icon className={cn('h-20 w-20 me-12', iconClassName)} fillColorToken={iconColor} />
      ) : null}
      <Typography className={textColor} variant={variant}>
        {content}
      </Typography>
    </Box>
  );
};

export default InformationBox;
